import type { IconName } from '@fortawesome/fontawesome-svg-core';
import React from 'react';

import Icon from '@components/Icon/Icon';
import SkeletonLoader from '@components/SkeletonLoader';

import { getImageSrc } from '@utils/image-handler';

export default function Image({
  alt = '',
  fallback,
  cssStyle,
  s3_key,
  img_src,
  width,
  height,
  loading: baseLoading = true,
}: {
  alt?: string;
  fallback?: IconName;
  cssStyle?: React.CSSProperties;
  s3_key?: string | null;
  img_src?: string | null;
  width: number;
  height: number;
  loading?: boolean;
}) {
  const [error, setError] = React.useState(false);
  const [imgLoading, setImgLoading] = React.useState(baseLoading);

  const src = img_src ?? getImageSrc(s3_key, width, height);

  const handleError: React.ReactEventHandler<HTMLImageElement> = () => {
    setError(true);
  };

  return (
    <>
      {src && !error ? (
        <img
          alt={alt}
          onLoad={() => {
            setImgLoading(false);
          }}
          onError={handleError}
          src={src}
          style={{
            ...cssStyle,
            display: imgLoading ? 'none' : 'block',
          }}
        />
      ) : fallback ? (
        <Icon
          color="primary.main"
          name={fallback}
          style={{ verticalAlign: 0, ...cssStyle }}
        />
      ) : null}
      {src && !error && imgLoading && (
        <SkeletonLoader
          height={height}
          loading={imgLoading}
          sx={{ ...cssStyle }}
          variant={cssStyle?.borderRadius ? 'circular' : 'rectangular'}
        >
          {' '}
        </SkeletonLoader>
      )}
    </>
  );
}
